import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Suspense} from 'react';
import {createStore, applyMiddleware, compose} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import reducers from './reducers/'
import socketMiddleware from './middleware/socketMiddleware';
import './i18n';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const store = createStore(reducers, compose(applyMiddleware(thunk, socketMiddleware)))


ReactDOM.render(
    <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Suspense fallback="...is loading">
                <App/>
            </Suspense>
        </LocalizationProvider>
    </Provider>,
    document.getElementById('root')
);